// src/integrations/supabase/client.ts
import { createClient } from "@supabase/supabase-js";
import type { Database } from "./types";

// --- Constants ---
const SUPABASE_URL = "https://thqwjnmzjauvgyakldog.supabase.co";
const SUPABASE_ANON_KEY =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InRocXdqbm16amF1dmd5YWtsZG9nIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjE4Mzk4MzcsImV4cCI6MjA3NzQxNTgzN30.DimlqZngUMFhY56G7gzn7GGmojm6bB9EiE0GqnBHhYk";

// --- Create Supabase client ---
export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    // ✅ Store session locally and auto-refresh it
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  },
  global: {
    headers: {
      // ✅ This ensures the anon key is always sent for public calls
      apikey: SUPABASE_ANON_KEY,
    },
  },
});
